<template>
    <transition name="slide-fade" >
        <div>
          <div class="uk-padding ">
            <h1 class="uk-heading-line uk-text-center"><span> Advisory Services</span></h1>
            <div class="uk-container uk-container-small" id="public-sector-board-support">

              <h3 class="uk-heading-bullet  h2Style">Public Sector Board support</h3>
              <p>
                With over a decade of experience on Public Sector Boards, we can help
                new or existing Boards navigate the requirements of the Public Authorities Act, understand
                procurement, understand budgeting, and develop a performance management framework for the CEO
                or Managing Director.
              </p>
              <p>
                We can also assist with the development of <a href="#">strategic plans</a>, review of board
                reports and documents, sit on interview panels, and help the organization stay onside with its legal
                requirements and remit. Remember, the Board does not manage the organization, it ensures the
                organization is well managed. Schedule a consultation with us today <a href="/contact-us">here</a>.
              </p>
            </div>
          </div>
          <div class="uk-padding uk-background-muted"  id="management-support">
            <div class="uk-container uk-container-small">

              <h3 class="uk-heading-bullet  h2Style">Management support</h3>
              <p>
                Whether you are a private business owner looking to take your business to the
                next level; preparing to make a pitch to the bank for financing; or struggling with the rigors of keeping
                up with trade and business licensing requirements, monthly payments, reporting requirements etc.
                FINCOR can help.
              </p>
              <p>
                We also provide support to new CEOs and Directors in the Public Sector to better
                understand the Government Framework, their key roles and responsibilities and meeting requirements
                under their specific Act. We can also provide guidance on overarching legislation such as the Public
                Authorities and Public Management and Finance Acts. Schedule a consultation with us today <a href="/contact-us">here</a>.
              </p>
            </div>
          </div>
          <div class="testStep">
            <div class="uk-padding uk-background-muted" style="background: rgba(0, 0, 0, 0.9)">
              <div class="uk-container uk-container-large">
                <div class="uk-child-width-1-3@l" uk-grid>
                  <div id="procurement-management">
                    <h3 class="uk-heading-bullet h2Style">Procurement Management</h3>
                    <p>
                      Do you have a major project and need to prepare a Request for Proposal? <br><br>
                      FINCOR can help you navigate the complex requirements of the Procurement Act and public sector
                      procurement policies and procedures.
                    </p>

                  </div>
                  <div id="business-case-preparation">
                    <h3 class="uk-heading-bullet h2Style">Business Case Preparation</h3>
                    <p>
                      We have supported entities in preparing Outline Business Cases based on
                      the UK Treasury’s Five-case model for over a decade.
                      <br><br>
                      We have acted as management support liaising
                      with big-4 accounting firms preparing Business Cases for multi-million dollar projects, and also led multi-
                      disciplinary teams advising Government on project feasibility, procurement planning, options analysis,
                      financing, and project implementation.
                    </p>

                  </div>
                  <div id="training">
                    <h3 class="uk-heading-bullet h2Style">Training</h3>
                    <p>
                      Looking for an experienced team to deliver a workshop on budgeting, financial management,
                      procurement, business case preparation or other public sector financial topics? We have successfully
                      developed and delivered multiple training workshops for Boards, accounting teams, middle managers
                      and staff looking to move up within their Department or Ministry.
                    </p>
                    <p>
                      The training we offer is not simply
                      theoretical, it is based on actual experience, knowledge of the local processes and legislation which
                      impact our clients in their day-to-day businesses.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
            <div class="uk-padding uk-background-muted" id="compliance-monitoring">
                <div class="uk-container uk-container-small">

                    <h3 class="uk-heading-bullet  h2Style">Compliance Monitoring</h3>
                  <p>
                    Have you lent or financed a business that is struggling to meet its obligations?
                    We can work with that client to advise on expense management, provide monthly/quarterly reporting
                    on performance indicators, and reduce the risk of default through compliance monitoring and ensuring
                    the business makes the decisions necessary to ensure survivability.
                  </p>
                  <p>
                    We have assisted numerous financial
                    institutions in this regard. All businesses placed under monitoring with us are still in operation and
                    maintain good relations with their banking institution. Schedule a consultation with us today
                    <router-link to="/contact-us" >here</router-link>.
                  </p>
<!--                    <ul class="uk-list uk-list-bullet">
                        We provide consulting services to a range of public and private entities in
                        key strategic areas including:
                        <li>Performance improvement;</li>
                        <li>Internal control system evaluation;</li>
                        <li>Provision of a rapid response team when you need focused resources in the implementation of strategic initiatives;</li>
                        <li>Budget preparation;</li>
                        <li>Strategic planning;</li>
                        <li>Development of policies and procedures; and</li>
                        <li>Provision of policy advice and governance services.</li>
                    </ul>-->
                </div>
            </div>

            <div class="uk-padding" id="notary-services">
                <div class="uk-container uk-container-small">

                    <h3 class="uk-heading-bullet h2Style">Notary Services</h3>
                    <p>
                      We offer Notary Public services for official documents required for Banks,
                      Government and regulatory agencies. Our full-time clients also receive this as a complementary service.
                      Please give us a call <router-link to="/contact-us">here</router-link> for your Notary Public needs.
                    </p>
<!--                    <ul class="uk-list uk-list-bullet">
                        FINCOR can assist agencies with public procurement needs by:
                        <li>Drafting Tender documents;</li>
                        <li>Placing adverts on behalf of Agencies;</li>
                        <li>Developing the assessment matrix;</li>
                        <li>Assisting with the Tender evaluation process; and</li>
                        <li>Assisting with the draft ESTAR report for the Entity or Public Procurement Committee (PPC).</li>
                    </ul>
                    <p>
                        We will ensure that your procurement process complies with the
                        requirements of the Procurement Law, Public Management and
                        Finance Law, and underpinning Regulations. We work with agencies
                        to ensure procurement is carried out timely, strategically and
                        transparently, and results in the achievement of value for money.
                    </p>-->
                </div>
            </div>
          <ContactStrip />


        </div>
    </transition>
</template>

<script>
    import ContactStrip from "@/components/parts/ContactStrip.vue";

    export default {
        name: "advisory",
      components: {ContactStrip},
      metaInfo: {
        title: ' Financial Advisory Services',
        meta: [{
          content: 'At FINCOR we provide financial advisory services such as: Business Consulting, Strategic Planning, Business Case Preparation, Development of Policies & Procedures and Procurement advisory services.'
        }]
      }
    }
</script>

<style scoped>
    .h2Style{
        font-family: 'Overlock SC';

    }
    .testStep{
        background-image: url('~@/assets/bg8.jpg');
        background-size: cover;
    }
    .testStep *{
        color: silver;
    }
</style>